<template>
  <div v-loading="true" class="auth-handler"></div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'AuthHandler',
  created() {
    const {mode, oobCode} = this.$route.query;
    if (mode === 'verifyEmail') {
      authFirestore.applyActionCode(oobCode).then(() => {
        this.$notify.success({
          offset: 60,
          title: 'Успешно',
          message: 'Ваш email подтвержден',
        });
      }).catch((error) => {
        this.$notify.error({
          offset: 60,
          title: 'Ошибка',
          message: error,
        });
      }).finally(() => {
        setTimeout(() => {
          this.$router.push('/');
        }, 2000);
      });
    } else {
      authFirestore.checkActionCode(oobCode).then((response) => {
        this.$router.push(`/sign/${mode}/${oobCode}`);
      }).catch(() => {
        this.$router.push('/');
      });
    }
  },
};
</script>

<style scoped lang="scss">
.auth-handler {
  min-height: 100vh;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Authorization/AuthHandler.vue